import { oc } from "@orpc/contract";
import * as z from "zod";
import { Id } from "./ids.js";

/** Cobble business mode: people in the instance's business and the invitations waiting for them. */
export const BusinessRoleSchema = z.enum(["owner", "admin", "member"]);
export type BusinessRole = z.infer<typeof BusinessRoleSchema>;

export const BusinessMemberSchema = z.object({
  userId: z.string(),
  email: z.string(),
  name: z.string(),
  role: BusinessRoleSchema,
  joinedAt: z.string(),
  isYou: z.boolean(),
});
export type BusinessMember = z.infer<typeof BusinessMemberSchema>;

export const BusinessInvitationSchema = z.object({
  id: z.string(),
  email: z.string(),
  role: BusinessRoleSchema,
  expiresAt: z.string(),
});
export type BusinessInvitation = z.infer<typeof BusinessInvitationSchema>;

export const BusinessMembersSchema = z.object({
  businessName: z.string(),
  yourRole: BusinessRoleSchema,
  canManage: z.boolean(),
  members: z.array(BusinessMemberSchema),
  invitations: z.array(BusinessInvitationSchema),
});
export type BusinessMembers = z.infer<typeof BusinessMembersSchema>;

export const membersContract = {
  list: oc.output(BusinessMembersSchema),
  invite: oc
    .input(z.object({ email: z.string().trim().toLowerCase().email().max(254), role: BusinessRoleSchema }))
    .output(BusinessMembersSchema),
  revokeInvitation: oc.input(z.object({ invitationId: z.string().min(1).max(64) })).output(BusinessMembersSchema),
  setRole: oc.input(z.object({ userId: Id, role: BusinessRoleSchema })).output(BusinessMembersSchema),
  remove: oc.input(z.object({ userId: Id })).output(BusinessMembersSchema),
};
